export default "__VITE_ASSET__CAakvjUx__"